var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81909 3.85547H8.67451V7.71089H4.81909V3.85547Z",
    fill: "#362044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5301 0V11.5663H0.963867V0H12.5301ZM10.6024 1.92771H2.89158V9.63855H10.6024V1.92771ZM8.67471 23.1325H4.81929V26.988H8.67471V23.1325Z",
    fill: "#362044"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5299 19.2772V30.8434H0.963623V19.2772H12.5299ZM2.89133 21.2049V28.9157H10.6022V21.2049H2.89133ZM24.0962 3.85547H27.9516V7.71089H24.0962V3.85547Z",
    fill: "#362044"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.241 0V11.5663H31.8072V0H20.241ZM29.8795 1.92771V9.63855H22.1687V1.92771H29.8795ZM16.3856 1.92771V0H18.3133V3.85542H16.3856V7.71084H14.4578V1.92771H16.3856ZM16.3856 11.5663V7.71084H18.3133V11.5663H16.3856ZM12.5301 15.4217V13.494H14.4578V11.5663H16.3856V15.4217H18.3133V13.494H27.9518V15.4217H20.241V17.3494H14.4578V15.4217H12.5301ZM12.5301 15.4217V17.3494H4.81929V15.4217H2.89158V17.3494H0.963867V13.494H6.747V15.4217H12.5301ZM31.8072 17.3494H29.8795V13.494H31.8072V17.3494ZM29.8795 17.3494H27.9518V21.2048H31.8072V19.2771H29.8795V17.3494ZM22.1687 17.3494H26.0241V19.2771H24.0964V21.2048H22.1687V17.3494ZM26.0241 23.1325V21.2048H24.0964V23.1325H22.1687V25.0602H18.3133V26.988H24.0964V23.1325H26.0241ZM26.0241 23.1325H31.8072V25.0602H27.9518V26.988H26.0241V23.1325ZM18.3133 21.2048V23.1325H20.241V19.2771H14.4578V21.2048H18.3133Z",
    fill: "#362044"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4574 23.1328H16.3851V28.9159H24.096V30.8437H14.4574V23.1328ZM31.8068 26.9882V30.8437H26.0237V28.9159H29.8791V26.9882H31.8068Z",
    fill: "#362044"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.85d1dec6026b5bce92dba7fc04759672.svg";
export { ForwardRef as ReactComponent };